<template>
  <div class="header" id="header">
    <div class="header-bar-outer">
      <div class="bar josefin">
        <div class="bar-inner box">
          <router-link class="mre-link-bar maisy" tag="div" to="/maisy" key="r1"
            :class="{ selected: channel === 'maisy' }">MAISY - TOP</router-link>
          <router-link class="mre-link-bar refly" tag="div" to="/refly" key="r2"
            :class="{ selected: channel === 'refly' }">Re:Fly - TOP</router-link>
          <router-link class="mre-link-bar emekare" tag="div" to="/emekare" key="r3"
            :class="{ selected: channel === 'emekare' }"><span class="mplus">エメ☆カレ</span> - TOP</router-link>
        </div>
      </div>
      <div class="title josefin">
        <div class="title-inner box">
          <router-link tag="div" :to="`#header`" key="0" class="title-text">
            Unit Stories M<img :src="'img/batsu_mre.png'" alt="x" class="batsu">R<img :src="'img/batsu_mre.png'" alt="x"
              class="batsu">E
          </router-link>
          <div class="title-link josefin">
            <router-link class="title-link-text" tag="div" :to="`/schedule`" key="0"
              :class="{ selected: page === 'schedule' }">schedule &
              ticket</router-link><span class="divider-vertical">|</span>
            <router-link class="title-link-text" tag="div" :to="`/event`" key="1"
              :class="{ selected: page === 'event' }">event & present</router-link>
              <span class="divider-vertical">|</span>
            <router-link class="title-link-text" tag="div" :to="`/goods`" key="2"
              :class="{ selected: page === 'goods' }">goods</router-link>
              <span class="divider-vertical">|</span>
            <router-link class="title-link-text" tag="div" :to="`/guide`" key="3"
              :class="{ selected: page === 'guide' }">guide</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: [
    'page'
  ],
  components: {
  },
  computed: {
    channel() {
      let channel = this.$store.state.channel;
      return channel;
    },
  }
}
</script>

<style scoped lang="scss">
.header-bar-outer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 107px;
}

.bar {
  color: white;
  display: flex;
  border: 0;
  width: 100%;
  margin: 0 auto;
  background: url(../../public/img/mre_menu.png) no-repeat, linear-gradient(to right, $liteorange, $liteorange 50%, $litegreen 50%, $litegreen), ;
  background-size: 1024px auto, 100%;
  background-position: center top, center top;
  line-height: 1.3;

  &:hover {
    cursor: pointer;
  }

  &-inner {
    display: flex;
  }

  .mre-link-bar {
    width: calc(100% / 3);
    transition: 0.5s;
    color: white;
    padding: 0.625rem 0.25rem 0.25rem;
    font-weight: 700;
    font-size: 1.1rem;
    position: relative;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }

    &.emekare {
      padding: 0.25rem;

      @media screen and (max-width: 768px) {
        padding: 0.5rem 0 0.2rem;
      }
    }

    &.maisy {
      background-color: $liteorange;

      &:hover {
        background-color: $orange;
      }
    }

    &.refly {
      background-color: $liteblue;

      &:hover {
        background-color: $blue;
      }
    }

    &.emekare {
      background-color: $litegreen;

      &:hover {
        background-color: $green;
      }
    }
  }
}

.title {
  background: url(../../public/img/mre_menu.png) no-repeat, linear-gradient(to right, $liteorange, $liteorange 50%, $litegreen 50%, $litegreen), ;
  background-size: 1024px auto, 100%;
  background-position: center top, center top;
  text-align: center;
  opacity: 0.8;
  @media screen and (max-width: 768px) {
      background-size: 100% 100%, 100% 100%;
    }
  &-inner {
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
}

.title-text {
  font-size: 1.9 * $rem;
  text-align: left;
  justify-self: flex-start;
  padding: 0.75rem 2rem 0.25rem;
  font-weight: 600;
  line-height: 1;
  color: white;
  width: 37%;
  white-space: nowrap;

  @media screen and (max-width: 768px) {
    width: 100%;
    font-size: 1.2rem;
    justify-self: center;
    text-align: center;
  }
  @media screen and (min-width: 1024px) {
    font-size: 1.9rem;
  }
}

.title-link {
  width: 63%;
  display: flex;
  text-transform: uppercase;
  font-size: 1.1 * $rem;
  padding-top: 0.25rem;
  justify-content: flex-end;
  padding-right: 2rem;
  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding-right: 0;
    font-size: 1.1rem;
  }
  @media screen and (min-width: 1024px) {
    font-size: 1.1rem;
  }

  &-text {
    color: white;
    transition: 0.33s;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
    &:hover {
      cursor: pointer;
      color: $white-op5;
    }

    &.selected {
      color: $white-op5;
    }
  }
}

.divider-vertical {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  color: $white-op5;

  @media screen and (max-width: 768px) {

    margin-right: 0.25rem;
    margin-left: 0.25rem;
    transform: translateY(-6px);
  }
}

.batsu {
  display: inline;
  height: 0.7em;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}</style>